import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Loading from "../components/Loading";

// Eye Icon for Display Games button
const EyeIcon = () => (
  <svg viewBox="64 64 896 896" focusable="false" width="1em" height="1em" fill="currentColor">
    <path d="M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z" />
  </svg>
);

const InplayCasinoPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [games, setGames] = useState([
    { id: 4,  name: "Teenpatti 2020",      slug: "teen20"   },
    { id: 1,  name: "20-20 Dragon Tiger",  slug: "dt20"     },
    { id: 2,  name: "Lucky 7 - B",         slug: "lucky7eu" },
    { id: 3,  name: "Amar Akbar Anthony",  slug: "aaa"      },
    { id: 5,  name: "Teen Patti One Day",  slug: "teen1"    },
    // { id: 6,  name: "Andar Bahar",         slug: "ab20"     },
    { id: 7,  name: "Andar Bahar 2",       slug: "abj"      },
    { id: 8,  name: "32 Cards - A",        slug: "card32"   },
  ]);

  const handleView = (game) => {
    navigate(`/casino/game-detail/${game.id}`);
  };

  const handleDisplayGames = (game) => {
    navigate(`/casino/display-games/${game.slug}/${encodeURIComponent(game.name)}`);
  };

  return (
    <div className="w-full">
      <div className="flex justify-center">
        <div className="w-full px-2">
          <div className="bg-white rounded shadow border border-gray-200">
            {/* Header */}
            <div className="bg-gray-600 px-5 py-2 flex items-center justify-between">
              <span className="text-xl text-white font-normal capitalize">
                Active Games
              </span>
              <button
                onClick={() => navigate(-1)}
                className="bg-white text-gray-700 px-4 py-1 hover:bg-gray-100"
                style={{ borderRadius: 0 }}
              >
                Back
              </button>
            </div>

            {/* Table */}
            <div className="overflow-x-auto">
              {loading ? (
                <div className="flex justify-center py-8">
                  <Loading />
                </div>
              ) : (
                <table className="w-full border-collapse text-sm">
                  <thead>
                    <tr className="bg-gray-600 text-white">
                      <th className="p-3 border border-gray-500 text-left font-medium">
                        #
                      </th>
                      <th className="p-3 border border-gray-500 text-left font-medium">
                        Name
                      </th>
                      <th className="p-3 border border-gray-500 text-left font-medium">
                        Details
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {games.length === 0 ? (
                      <tr>
                        <td
                          colSpan="3"
                          className="p-8 text-center text-gray-500 bg-gray-50"
                        >
                          No active games found
                        </td>
                      </tr>
                    ) : (
                      games.map((game, index) => {
                        return (
                          <tr
                            key={game.id}
                            className="hover:bg-gray-50 border-b border-gray-200"
                          >
                            <td className="p-3 border border-gray-300 text-gray-800">
                              {index + 1}
                            </td>
                            <td className="p-3 border border-gray-300 text-gray-800">
                              {game.name}
                            </td>
                            <td className="p-3 border border-gray-300">
                              <div className="flex gap-2">
                                <button
                                  onClick={() => handleView(game)}
                                  className="bg-green-600 text-white px-4 py-1.5 hover:bg-green-700 transition-colors text-sm"
                                  style={{ borderRadius: 0 }}
                                >
                                  View
                                </button>
                                <button
                                  onClick={() => handleDisplayGames(game)}
                                  className="bg-green-600 text-white px-4 py-1.5 hover:bg-green-700 transition-colors text-sm inline-flex items-center gap-2"
                                  style={{ borderRadius: 0 }}
                                >
                                  <EyeIcon />
                                  Display Games
                                </button>
                              </div>
                            </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InplayCasinoPage;
